'use client';

import ReCAPTCHA from 'react-google-recaptcha';
import { useEffect, useRef, useState } from 'react';

export default function Recaptcha({ onChange, showWarning }: { onChange: (token: string | null) => void , showWarning: boolean}) {
    const recaptchaRef = useRef<ReCAPTCHA>(null);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(true);
    }, []);

    if (!loaded) {
        return null;
    }

    return (
        <div className="d-flex flex-column align-items-center mt-1">
            <ReCAPTCHA ref={recaptchaRef} sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!} onChange={onChange} />
            <span className="text-danger text-xs">{showWarning ? 'Please verify that you are not a robot' : ''}</span>
        </div>
    );
}
